import request from "@/utils/request";
import { path } from "../common";
import { exportExcel } from "@/utils/";

export function getAdvertisingPositionList(params) {
  return request({
    url: `/ad-operating/p-api/v1/ad/page`,
    params
  });
}

export function getAdvertisingPositionDetail(id,params) {
  return request({
    url: `/ad-operating/p-api/v1/ad/detail/${id}`,
    params
  });
}

export function editAdvertisingPosition(data) {
  return request({
    url: `/ad-operating/p-api/v1/ad/edit`,
    method: "post",
    data
  });
}

export function getIconClassifyList(params) {
  return request({
    url: `/ad-operating/p-api/v1/ico/category/list`,
    params
  });
}

export function getIconClassifyPage(params) {
  return request({
    url: `/ad-operating/p-api/v1/ico/category/page`,
    params
  });
}
export function updateIconClassify(data) {
  return request({
    url: `/ad-operating/p-api/v1/ico/category/edit`,
    method: "post",
    data
  });
}

export function getIconWarehouseList(params) {
  return request({
    url: `/ad-operating/p-api/v1/ico/library/page`,
    params
  });
}

export function addIconWarehouse(data) {
  return request({
    url: `/ad-operating/p-api/v1/ico/ico/edit`,
    method: "post",
    data
  });
}

export function getCityPage(params) {
  return request({
    url: `/ad-operating/p-api/v1/base/city/page`,
    params
  });
}

export function getCityList(params) {
  return request({
    url: `/ad-operating/p-api/v1/base/city/list`,
    params
  });
}
export function getAreaPage(params) {
  return request({
    url: `/ad-operating/p-api/v1/base/area/page`,
    params
  });
}
//获取区域列表
export function baseAreaList(params) {
  return request({
    url: `/ad-operating/p-api/v1/base/area/list`,
    params
  });
}

export function byCityGetArea(cityCode) {
  return request({
    url: `/ad-operating/p-api/v1/base/district/list/${cityCode}`
  });
}

export function editArea(data) {
  return request({
    url: `/ad-operating/p-api/v1/base/area/edit`,
    method: "post",
    data
  });
}

export function getDistrictPage(params) {
  return request({
    url: `/ad-operating/p-api/v1/base/lot/page`,
    params
  });
}

export function generateDistrictCode(areaCode) {
  return request({
    url: `/ad-operating/p-api/v1/base/lot/code/${areaCode}`
  });
}

export function byAreaGetDistrict(areaCode) {
  return request({
    url: `/ad-operating/p-api/v1/base/lot/list/${areaCode}`
  });
}

export function editDistrict(data) {
  return request({
    url: `/ad-operating/p-api/v1/base/edit/lot`,
    method: "post",
    data
  });
}

export function editDistrictStatus(status, id) {
  return request({
    url: `/ad-operating/p-api/v1/base/change/lot/${status}/${id}`,
    method: "post"
  });
}


export function getPrice(params) {
  return request({
    url: `/ad-operating/p-api/v1/price/adv/price`,
    params
  });
}
